var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.chartOptions
    ? _c("VueApexChart", {
        ref: "chart",
        staticClass: "app-chart-stacked-bar",
        class: { live: _vm.autoUpdate },
        attrs: {
          height: "100%",
          width: "100%",
          type: "bar",
          options: _vm.chartOptions,
          series: _vm.series
        }
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0e0b01b6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e0b01b6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/app-components/AppChartStackedBar.vue
// module id = null
// module chunks = 